import React from "react";
import "./IdealPaymentType.scss";
import { FormattedMessage } from "react-intl";
import AmountContainer from "app/pages/.shared/AmountContainer";
import PictoRadio from "app/pages/.shared/PictoRadio";
import PropTypes from "prop-types";

class IdealPaymentType extends React.PureComponent {
	render() {
		const { total, onIssuerSelect, idealIssuers = [], field = {} } = this.props;

		return (
			<div className="ideal-payment-type">
				<div className="ideal-payment-type__pay-amount">
					<FormattedMessage id="payment.pay.all" />
					<span>
						<AmountContainer amount={total} />
					</span>
				</div>
				<div className="ideal-payment-type__select-message">
					<FormattedMessage id="payment.methods.ideal.select.bank" />
				</div>
				<div className="ideal-payment-type__banks">
					{idealIssuers.map(issuer => {
						const isBankSelected = field.value === issuer.id;
						return (
							<div
								className="ideal-payment-type__banks--item"
								key={`bank${issuer.id}`}
							>
								<PictoRadio
									field={field}
									name={issuer.id}
									id={issuer.id}
									value={issuer.id}
									checked={isBankSelected}
									toggle={() => {
										onIssuerSelect(issuer.id);
									}}
									icon={
										<i
											className={`icon icon--${issuer.name
												.toLowerCase()
												.replace(/ /g, "-")}`}
										/>
									}
									label={issuer.name}
								/>
							</div>
						);
					})}
				</div>
			</div>
		);
	}
}

IdealPaymentType.propTypes = {
	total: PropTypes.number,
	onIssuerSelect: PropTypes.func,
	idealIssuers: PropTypes.array,
	field: PropTypes.object,
};

export default IdealPaymentType;
